module.exports = __webpack_public_path__ + "img/EM.69041e92.png";